import React, { useState, useEffect } from 'react';
import { Play, Edit3, Share2, Download, Trash2, Music, ArrowLeft, Loader2, Copy, Check } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const TOKEN_KEY = 'ltbb-ba-token';

export const StudentDashboard = ({ onBack, onEditBeat }) => {
  const [beats, setBeats] = useState([]);
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [copiedSlug, setCopiedSlug] = useState(null);

  const token = localStorage.getItem(TOKEN_KEY);

  useEffect(() => {
    if (!token) return;
    fetch(`${BACKEND_URL}/api/v1/platform/my-beats`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.json())
      .then(d => { setBeats(d.beats || []); setCount(d.count || 0); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [token]);

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this beat?')) return;
    await fetch(`${BACKEND_URL}/api/v1/projects/${id}`, { method: 'DELETE', headers: { Authorization: `Bearer ${token}` } });
    setBeats(b => b.filter(x => x.id !== id));
    setCount(c => c - 1);
  };

  const handleShare = async (id) => {
    const res = await fetch(`${BACKEND_URL}/api/v1/platform/share-link`, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify({ project_id: id }),
    });
    const data = await res.json();
    if (data.slug) {
      const url = `${window.location.origin}/listen/${data.slug}`;
      navigator.clipboard.writeText(url).then(() => setCopiedSlug(data.slug));
      setTimeout(() => setCopiedSlug(null), 2000);
      // Update beats with slug
      setBeats(b => b.map(x => x.id === id ? { ...x, share_slug: data.slug } : x));
    }
  };

  return (
    <div data-testid="student-dashboard" style={{ minHeight: '100vh', background: '#0A0A0A', color: '#fff', fontFamily: "'Barlow', 'Inter', sans-serif" }}>
      <div style={{ maxWidth: 700, margin: '0 auto', padding: '24px 16px' }}>
        {/* Header */}
        <div className="flex items-center gap-3" style={{ marginBottom: 24 }}>
          {onBack && <button onClick={onBack} style={{ background: '#1A1A1A', border: '1px solid #2A2A2A', borderRadius: 22, width: 36, height: 36, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#aaa', cursor: 'pointer' }}><ArrowLeft size={16} /></button>}
          <div>
            <h1 style={{ fontSize: 22, fontWeight: 700, margin: 0 }}>My Beats</h1>
            <span style={{ fontSize: 13, color: '#666' }}>You have {count} beat{count !== 1 ? 's' : ''} saved (15 max)</span>
          </div>
        </div>

        {count >= 12 && <div style={{ background: '#FF002215', border: '1px solid #FF002244', borderRadius: 10, padding: '10px 16px', marginBottom: 16, fontSize: 12, color: '#FF0022' }}>You're close to the limit! Delete unused beats to make room.</div>}

        {loading && <div className="flex justify-center py-12"><Loader2 size={24} className="animate-spin" style={{ color: '#666' }} /></div>}

        {!loading && beats.length === 0 && (
          <div className="flex flex-col items-center py-16 gap-3">
            <Music size={32} style={{ color: '#333' }} />
            <span style={{ fontSize: 14, color: '#666' }}>No beats yet. Start creating!</span>
          </div>
        )}

        {!loading && beats.map(beat => (
          <div key={beat.id} style={{ background: '#1A1A1A', border: '1px solid #2A2A2A', borderRadius: 12, padding: '16px', marginBottom: 10 }}>
            <div className="flex items-start justify-between gap-2" style={{ marginBottom: 8 }}>
              <div>
                <span style={{ fontSize: 15, fontWeight: 600 }}>{beat.name}</span>
                <div style={{ fontSize: 11, color: '#666', marginTop: 2 }}>
                  {beat.bpm} BPM &middot; {beat.total_bars} bars &middot; Last edited {new Date(beat.updated_at).toLocaleDateString()}
                </div>
              </div>
            </div>
            <div className="flex flex-wrap gap-2">
              <button onClick={() => onEditBeat?.(beat.id)} style={{ height: 30, borderRadius: 22, padding: '0 14px', fontSize: 11, fontWeight: 600, background: '#00D4AA', color: '#0A0A0A', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 4 }}><Edit3 size={12} /> Edit</button>
              <button onClick={() => handleShare(beat.id)} style={{ height: 30, borderRadius: 22, padding: '0 14px', fontSize: 11, fontWeight: 600, background: '#1A1A1A', color: '#00D4AA', border: '1px solid #00D4AA', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 4 }}>
                {copiedSlug && beat.share_slug === copiedSlug ? <><Check size={12} /> Copied!</> : <><Share2 size={12} /> Share Link</>}
              </button>
              <button onClick={() => handleDelete(beat.id)} style={{ height: 30, borderRadius: 22, padding: '0 14px', fontSize: 11, fontWeight: 600, background: 'transparent', color: '#FF0022', border: '1px solid #FF002244', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 4 }}><Trash2 size={12} /> Delete</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StudentDashboard;
